
import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import { WORK_TYPE_BOOKN, WORK_TYPE_ORDER } from '../../Wizard/WizardConstants';

function getSteps(calStep, workTypeValue) {
    const typeName = workTypeValue !== "ORDER" ? WORK_TYPE_BOOKN:WORK_TYPE_ORDER

    if(calStep === 'true') {
        return [typeName + ' 접수', '가격 산정', '최종 ' + typeName, typeName + ' 완료'];
    }else {
        return [typeName + ' 접수', '최종 ' + typeName, typeName + ' 완료'];
    }
}

export function OrderStatus({ step, calStep, workTypeValue }) {
    const steps = getSteps(calStep, workTypeValue);

    return (
        <Stepper activeStep={step} alternativeLabel className="p-0 py-3 justify-content-center">
            {steps.map(label => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}
